import React from 'react'
import TextField from 'material-ui/TextField';

const UpsellOptions = ({styles, settings, handleChange}) => {
  console.log('settings', settings)
  return (
    <div><h2>Upsell Options</h2>
      <div className="content">
      <TextField
          floatingLabelText="Upsell Sku"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={settings.upsellSku}
          name="upsellSku"
          floatingLabelFixed={true}
          onChange={handleChange}
          style={styles.inputStyle}
        />
      <TextField
          floatingLabelText="Upsell Discount"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={settings.upsellDiscount}
          name="upsellDiscount"
          floatingLabelFixed={true}
          onChange={handleChange}
          style={styles.inputStyle}
        />
      <TextField
          floatingLabelText="Upsell Description"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={settings.upsellDescription}
          name="upsellDescription"
          floatingLabelFixed={true}
          onChange={handleChange}
          style={styles.inputStyle}
          multiLine={true}
        />
      </div>
    </div>
  )
}

export default UpsellOptions


// WEBPACK FOOTER //
// ./src/components/settings/UpsellOptions.js